import { render, staticRenderFns } from "./ConfirmRegister.vue?vue&type=template&id=05e3e7c2"
import script from "./ConfirmRegister.vue?vue&type=script&lang=ts"
export * from "./ConfirmRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports